
import { Base } from '../base-component';

import './content-card.component.scss';

import Slider from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

export class ContentCard extends Base {

	sliderContainer: Element;
	sliderPagination: Element;
	sliderConfig: SwiperOptions;
	sliderNext: Element;
	sliderPrev: Element;
	slidesPerColumn: number;
	items: Element[];

	constructor(element: Element ) {
		super(element);
	}

	init() {

		this.sliderContainer = this.element.querySelector('.swiper-container');
		this.sliderPagination = this.element.querySelector('.swiper-pagination');
		this.sliderNext = this.element.querySelector('.swiper-button-next');
		this.sliderPrev = this.element.querySelector('.swiper-button-prev');

		if (this.element.classList.contains('content-card--single')) {
			this.slidesPerColumn = 1;
		} else {
			this.slidesPerColumn = 2;
		}

		this.initSlider();

		if (this.slidesPerColumn > 1) {
			this.initAlternatingSlideStyles();
		}

	}

	bindEvents() {}

	setSliderConfig() {

		this.sliderConfig = {
			spaceBetween: 0,
			slidesPerView : 2,
			slidesPerColumn: this.slidesPerColumn,
			initialSlide: 0,
			breakpoints: {
				1023: {
					spaceBetween: 0,
					slidesPerView : 1,
					slidesPerColumn: 2,
					initialSlide: 0
				},
				767: {
					spaceBetween: 20,
					slidesPerView : 2.4,
					slidesPerColumn: 1,
					initialSlide: 0
				},
				576: {
					spaceBetween: 15,
					slidesPerView: 1.2,
					slidesPerColumn: 1,
					initialSlide: 0,
				}
			},
			pagination: {
				el: this.sliderPagination,
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: this.sliderNext,
				prevEl: this.sliderPrev
			}
		};

	}

	initSlider() {
		this.setSliderConfig();
		Slider.init(this.sliderContainer, this.sliderConfig);
	}

	initAlternatingSlideStyles() {

		let items = Array.from(this.element.querySelectorAll('.js-content-card-item-container'));

		for (let i = 0; i < items.length; i++) {

			let itemParent = items[i].parentNode;

			if (itemParent.attributes[0].value.indexOf('swiper-alt') >= 0) {

				items[i].querySelector('.content-card-item__link').classList.add('content-card-item__link--alt');
				items[i].querySelector('.content-card-item__content').classList.add('content-card-item__content--alt');
				items[i].querySelector('.content-card-item__image-holder').classList.add('content-card-item__image-holder--alt');

			}

		}

	}

}



// WEBPACK FOOTER //
// ./components/content-card/content-card.component.ts